import React, { useContext, useEffect, useState } from 'react';
import { Box, SelectChangeEvent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AppContext } from '@/utils/appContext';
import { ISearchForm } from '@/interfaces/bookingContext';
import { SearchBar } from '../../SearchBar';
import { SearchBarMobile } from './SearchBarMobile';
import { useLocation, useNavigate } from 'react-router-dom';
import { useResponsive } from '@/hooks/use-responsive';
import {useStyles} from "tss-react";

export const SearchTopBar = (props: any) => {

  // console.count('SearchTopBar')

  const appContext = useContext(AppContext);
  const location = useLocation();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const navigate = useNavigate();
  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  const [howGuests, setHowGuests] = useState<number>(0);
  const [howPets, setHowPets] = useState<number>(0);
  const [type, setType] = useState<string[]>([]);

  const sumGuests = () => {
    let count = 0;
    appContext.searchForms.forEach((sF: ISearchForm) => {
      count += sF.NoOfAdults;
      count += sF.ageOfChildren.length;
    });
    return count;
  };

  const sumPets = () => {
    let count = 0;
    appContext.searchForms.forEach((sF: ISearchForm) => {
      count += sF.Pets;
    });
    return count;
  };

  useEffect(() => {
    setHowGuests(sumGuests);
    setHowPets(sumPets);
  }, [appContext.searchForms]);

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleWhereChange = (event: SelectChangeEvent<{ name?: string; value: any }>) => {
    // appContext.resetAvailability();
    appContext.searchForms[appContext.orderIndex].property = '';
    appContext.searchForms[appContext.orderIndex].destination = String(event.target.value);
    appContext.setSearchForms([...appContext.searchForms]);
  };


  const handleChangeType = (value: any) => {
    // appContext.resetAvailability();
    type.push(value);
    appContext.setSearchForms([...appContext.searchForms]);
  };

  const setQuantity = (category: string, isIncrement: boolean, searchFormNum: number) => {
    // appContext.resetAvailability();
    const searchForm = [...appContext.searchForms];

    if (category === 'NoOfAdults') {
      if (isIncrement) {
        searchForm[searchFormNum][category] += 1;
      } else if (!isIncrement && searchForm[searchFormNum][category] > 1) {
        searchForm[searchFormNum][category] -= 1;
      }
    } else if (category === 'Children') {
      if (isIncrement) {
        searchForm[searchFormNum].ageOfChildren.push(-1);
      } else {
        searchForm[searchFormNum].ageOfChildren.pop();
      }
    }
    // searchForm[searchFormNum].status = 'to_start';
    appContext.setSearchForms(searchForm);
    sumGuests();
  };


  const setPets = (isIncrement: boolean, indexForm: number) => {
    // appContext.resetAvailability();
    const searchForm = [...appContext.searchForms];
    if (isIncrement && searchForm[indexForm]['Pets'] < 2) {
      searchForm[indexForm]['Pets'] += 1;
    } else if (!isIncrement && searchForm[indexForm]['Pets'] > 0) {
      searchForm[indexForm]['Pets'] -= 1;
    }
    appContext.setSearchForms(searchForm);
    sumPets();
  };

  const handleCouponChange = (event: React.ChangeEvent<{ name?: string; value: any }>) => {
    // appContext.resetAvailability();
    // appContext.searchForms[appContext.orderIndex].status = 'to_start';
    appContext.searchForms[appContext.orderIndex].Coupon = event.target.value.toUpperCase();
    appContext.setSearchForms([...appContext.searchForms]);
  };

  const addSearchForm = () => {
    appContext.searchForms.push({
      property: appContext.searchForms[appContext.orderIndex].property,
      destination: appContext.searchForms[appContext.orderIndex].destination,
      GuestArrival: appContext.searchForms[appContext.orderIndex].GuestArrival,
      GuestDeparture: appContext.searchForms[appContext.orderIndex].GuestDeparture,
      NoOfAdults: 2,
      ageOfChildren: [],
      Child: undefined,
      typeOfHoliday: '',
      landscape: '',
      Coupon: '',
      Pets: 0,
      // status: 'to_start',
      autoSearch: false
    });
    appContext.setSearchForms([...appContext.searchForms]);
  };

  const removeSearchForm = (index: number) => {
    const searchForms = [...appContext.searchForms];
    searchForms.splice(index, 1);
    appContext.setSearchForms(searchForms);
  };

  const [openSearchMobileModal, setOpenSearchMobileModal] = useState<boolean>(false);

  const handleOpenSearchMobileModal = () => setOpenSearchMobileModal(true);
  const handleCloseSearchMobileModal = () => {
    setOpenSearchMobileModal(false);
    appContext.setMobileSubmitBtn(false);
  };

  const open = Boolean(anchorEl);
  const onKeyDown = (e: any) => {
    e.preventDefault();
  };

  const upMd = useResponsive('up', 'md');
  const downMd = useResponsive('down', 'md');

  const submitSearchBar = async () => {
    await appContext.getAvailability();
  };

  return (
    <Box sx={{ position: { xs: 'sticky', md: 'initial' }, top: 0, zIndex: 9999999 }}>
      <form name="booking-online" className="nocaptcha" onSubmit={props.container === 'SearchBarWidget' ? props.params.handleSubmit : submitSearchBar}>
        {
          upMd && (
            <Box id={"searchBarBox"} pt={5} pb={5}>
              <SearchBar
                params={{
                  handleWhereChange,
                  onKeyDown,
                  howGuests,
                  howPets,
                  setQuantity,
                  setPets,
                  handleCouponChange,
                  handlePopoverOpen,
                  handlePopoverClose,
                  open,
                  setAnchorEl,
                  anchorEl,
                  addSearchForm
                }}
              />
            </Box>
          )
        }

        {
          downMd && (
            <>
              {!openSearchMobileModal && (
                <SearchBarMobile
                  params={{
                    handleWhereChange,
                    howGuests,
                    setQuantity,
                    howPets,
                    setPets,
                    handleCouponChange,
                    handleOpenSearchMobileModal,
                    sumGuests,
                    addSearchForm,
                    removeSearchForm
                  }}
                />
              )}
            </>
          )
        }
      </form>
    </Box>
  );
};
